export const FEDEX_IP_RATES: Record<number, number> = {
  0.5: 12402, 1.0: 16386, 1.5: 20371, 2.0: 24355, 2.5: 28340,
  3.0: 32201, 3.5: 36062, 4.0: 39923, 4.5: 43784, 5.0: 47645,
  5.5: 48626, 6.0: 49608, 6.5: 50589, 7.0: 51571, 7.5: 52552,
  8.0: 53534, 8.5: 54515, 9.0: 55497, 9.5: 56478, 10.0: 57460,
  10.5: 58448, 11.0: 59436, 11.5: 60424, 12.0: 61412, 12.5: 62400,
  13.0: 63388, 13.5: 64376, 14.0: 65364, 14.5: 66352, 15.0: 67340,
  15.5: 68328, 16.0: 69316, 16.5: 70304, 17.0: 71292, 17.5: 72280,
  18.0: 73268, 18.5: 74256, 19.0: 75244, 19.5: 76232, 20.0: 77220,
  20.5: 78208
};

export const FEDEX_IE_RATES: Record<number, number> = {
  2.0: 23985, 2.5: 27924, 3.0: 31661, 3.5: 35399, 4.0: 39136,
  4.5: 42874, 5.0: 46611, 5.5: 47586, 6.0: 48561, 6.5: 49536,
  7.0: 50511, 7.5: 51486, 8.0: 52461, 8.5: 53436, 9.0: 54411,
  9.5: 55386, 10.0: 56361, 10.5: 56920, 11.0: 57479, 11.5: 58038,
  12.0: 58597, 12.5: 59156, 13.0: 59715, 13.5: 60274, 14.0: 60833,
  14.5: 61392, 15.0: 61951, 15.5: 62510, 16.0: 63069, 16.5: 63628,
  17.0: 64187, 17.5: 64746, 18.0: 65305, 18.5: 65864, 19.0: 66423,
  19.5: 66982, 20.0: 67541, 20.5: 68100
};

export function getFedexRate(weightKg: number, type: 'priority' | 'economy'): number {
  // Round up to nearest 0.5kg
  const stepWeight = Math.ceil(weightKg * 2) / 2;
  const rates = type === 'priority' ? FEDEX_IP_RATES : FEDEX_IE_RATES;
  
  if (stepWeight <= 20.5) {
    if (rates[stepWeight]) {
      return rates[stepWeight];
    }
    // For economy, weights below 2.0 aren't in the table, fallback to priority or min 2.0
    if (type === 'economy' && stepWeight < 2.0) {
      return rates[2.0];
    }
  }

  // Handle heavier weights
  let multiplier = 0;
  if (type === 'priority') {
    if (weightKg >= 21.0 && weightKg <= 44.0) multiplier = 3744;
    else if (weightKg >= 45.0 && weightKg <= 70.0) multiplier = 3374;
    else if (weightKg >= 71.0) multiplier = 3348;
  } else {
    if (weightKg >= 21.0 && weightKg <= 44.0) multiplier = 3257;
    else if (weightKg >= 45.0 && weightKg <= 70.0) multiplier = 2938;
    else if (weightKg >= 71.0) multiplier = 2919;
  }
  
  if (multiplier > 0) {
    return Math.ceil(weightKg) * multiplier; // Usually billed per full kg above 21kg
  }
  
  return rates[20.5]; // Fallback
}
